import { z } from "zod";
export const AttributionTierPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("attribution-tier-policy.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalAttributionTierPolicy(recordedAt) {
    return AttributionTierPolicyV1Schema.parse({
        schemaVersion: "attribution-tier-policy.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=attribution-tier-policy.js.map